import { render, staticRenderFns } from "./SearchProductsPopup.vue?vue&type=template&id=782ebf28&scoped=true&"
import script from "./SearchProductsPopup.vue?vue&type=script&lang=js&"
export * from "./SearchProductsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductsPopup.vue?vue&type=style&index=0&id=782ebf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782ebf28",
  null
  
)

export default component.exports